import { countryData, CountryType } from "@letshang/assets"
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber"

const phoneUtil = PhoneNumberUtil.getInstance()

export const getDefaultCountry = (): CountryType => {
  // Try to get user's locale country first
  const userLocale = navigator?.language || "en-US"
  const regionCode = userLocale.split("-")[1] || "US"

  // Find country by user's region
  const userCountry = countryData.find(
    (country) => country.code.toUpperCase() === regionCode.toUpperCase(),
  )

  if (userCountry?.dial_code) {
    return userCountry
  }

  // Fallback to US
  const usCountry = countryData.find((country) => country.code === "US")
  if (usCountry?.dial_code) {
    return usCountry
  }

  // Ultimate fallback - first country with dial_code
  const validCountry = countryData.find((country) => country.dial_code)
  if (validCountry) {
    return validCountry
  }

  // Emergency fallback
  return {
    name: "United States",
    code: "US",
    dial_code: "+1",
    flag: "",
  }
}

export const getFormattedPhone = (
  digits: number | string,
  country: CountryType,
) => {
  try {
    const inputNumber = String(digits || "").replace(/[^\d+]/g, "")
    if (!inputNumber) {
      console.error("Input number is empty or invalid")
      return
    }
    // Validate the country code
    if (!country || !country.code) {
      console.error("Country code is missing or invalid")
      return
    }

    if (inputNumber.length < 2) {
      return inputNumber
    }
    // Parse the number
    const parsedNumber = phoneUtil.parse(inputNumber, country.code)

    // Format the number in NATIONAL format
    let formattedDisplay = phoneUtil.format(
      parsedNumber,
      PhoneNumberFormat.NATIONAL,
    )

    // Remove leading '0' if present
    if (formattedDisplay.startsWith("0")) {
      formattedDisplay = formattedDisplay.replace(/^0/, "")
    }

    return formattedDisplay
  } catch (error) {
    console.error("Error formatting phone number:", JSON.stringify(error))
    // setPhoneDisplayed("Invalid phone number");
  }
}
